/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ManageUsers32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlGray80}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 7a9 9 0 110 18 9 9 0 010-18zm0 10.688c-1.361 0-2.58.464-3.636 1.233-.63.457-1.072.919-1.314 1.242a.563.563 0 00.9.674c.04-.052.128-.158.263-.3.23-.24.503-.481.813-.707.877-.638 1.873-1.017 2.974-1.017 1.101 0 2.098.379 2.974 1.017.31.225.582.466.813.708.135.14.224.247.263.3a.563.563 0 00.9-.675c-.242-.323-.683-.785-1.314-1.242-1.056-.769-2.275-1.233-3.636-1.233zm0-6.75a2.814 2.814 0 000 5.624 2.814 2.814 0 000-5.625zm0 1.124a1.688 1.688 0 11-.001 3.377A1.688 1.688 0 0116 12.062z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default ManageUsers32;
